import React, {Fragment, useRef, useState} from 'react';
import {useTheme} from "@material-ui/core";
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import { Field} from 'react-final-form';
import {Select} from '../../';
import {connect} from 'react-redux';


function SelectListSection(props){
    let lists=(props.remove_new_list==true)?[]:[{id:'new', name:'New'}];
    if(props.lists!=undefined){for(let key in props.lists){lists.push({id:key, name:props.lists[key].name});}}
    return(
      <Fragment>
        <Grid item xs={6} sm={4}><Select title='List' name='list_id' style={{width:(props.no_style_list_id==true)?'100%':'calc(100% - 20px)', marginLeft:(props.no_style_list_id==true)?undefined:'10px', marginTop:'10px', backgroundColor:'#f7f9fc'}}  select_data={lists}/></Grid>
        <Field name='list_id'>{(f_id)=>{
          if(f_id.input.value=='new'){
            return(<Grid item xs={6} sm={4}><Field name='list_name'>{(f)=>{if(props.setListDone!=undefined){if(f.input.value!='' && f.input.value!=undefined){props.setListDone(true)}else{props.setListDone(false);}} return(<TextField required error={(props.automated_error || props.list_error)} helperText={(props.automated_error==true || props.list_error==true)?'Required':null} size='small' variant='outlined' label='List name' value={f.input.value} onChange={f.input.onChange} style={{width:'calc(100% - 20px)', marginLeft:'10px', marginTop:'10px', backgroundColor:'#f7f9fc'}} />)}}</Field></Grid>);
          }else{
            if(props.setListDone!=undefined){props.setListDone(true)}
            return(null)
          }
        }}
        </Field>
      </Fragment>
    )
}


export default connect(ss)(SelectListSection);


function ss(state){
  return{
    lists:state.lists.data,
    list_queue_refresh:state.lists.refresh,
    all_lists:state.lists.all_lists,
    }
}
